import { getPersistentItem } from '../vrs-auth/storage';
/**
 * Resolve the Deaf client's explicit interpreted-call camera preference.
 * Server values win so a changed preference reaches sleeping/cross-device
 * clients; the hydrated local value is the offline fallback. New clients
 * default to video on.
 */
export function getClientStartWithVideoMuted(serverValue) {
    if (typeof serverValue === 'boolean') {
        return serverValue;
    }
    const stored = getPersistentItem('vrs_incoming_video_enabled');
    return stored === 'false';
}
export function getInterpretedStartWithVideoMuted(role, clientServerValue) {
    return role === 'interpreter'
        ? false
        : getClientStartWithVideoMuted(clientServerValue);
}
